module.exports = __webpack_public_path__ + "img/face_auth_type_3.99aa56bc.png";